import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { exportCSV, exportXLSX } from '../api/client';

interface ExportButtonsProps {
  reportType: string;
  dateFrom: string;
  dateTo: string;
  siteIds?: string;
}

export const ExportButtons: React.FC<ExportButtonsProps> = ({
  reportType, dateFrom, dateTo, siteIds,
}) => {
  const { t } = useTranslation();
  const [exporting, setExporting] = useState<'csv' | 'xlsx' | null>(null);

  const handleExport = async (format: 'csv' | 'xlsx') => {
    setExporting(format);
    try {
      const params = { report_type: reportType, date_from: dateFrom, date_to: dateTo, site_ids: siteIds };
      const blob = format === 'csv'
        ? await exportCSV(params)
        : await exportXLSX(params);

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${reportType}_${dateFrom}_${dateTo}.${format}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(`Export ${format} failed:`, err);
    } finally {
      setExporting(null);
    }
  };

  return (
    <div className="flex gap-2">
      <button onClick={() => handleExport('csv')} disabled={!!exporting}
        className="rounded-md border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-300 dark:hover:bg-slate-600">
        {exporting === 'csv' ? t('export.exporting') : t('export.csv')}
      </button>
      <button onClick={() => handleExport('xlsx')} disabled={!!exporting}
        className="rounded-md border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-300 dark:hover:bg-slate-600">
        {exporting === 'xlsx' ? t('export.exporting') : t('export.excel')}
      </button>
    </div>
  );
};
